import { Injectable } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TruckSearchTable } from 'cargo-chief-commons';
import { CarrierDataFeedbackDialog } from '../../project/capacity-search-panel/carrier-data-feedback/carrier-data-feedback.component';

@Injectable({
	providedIn: 'root',
})
export class CarrierFeedbackService {
	constructor(private dialog: MatDialog) {}

	reportDataAction(
		dataType: string,
		searchTruckForm: any,
		capacitySearch: Partial<TruckSearchTable>
	): Promise<any> {
		const dialogRef = this.dialog.open(CarrierDataFeedbackDialog, {
			width: '850px',
			data: {
				lane: capacitySearch,
				search: searchTruckForm,
				incorrectDataType: dataType,
			},
		});
		return dialogRef.afterClosed().toPromise();
	}
}
